/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { useEffect, useState, Dispatch, SetStateAction } from 'react';
import Swal from 'sweetalert2';
import { ContainerTimer, Timer } from './style';

type Props = {
  intervalId: NodeJS.Timer;
  setShowPaymentMethod: Dispatch<SetStateAction<string>>;
};

export default function Cronometer({ intervalId, setShowPaymentMethod }: Props): JSX.Element {
  const [seconds, setSeconds] = useState(59);
  const [minutes, setMinutes] = useState(9);

  useEffect(() => {
    seconds >= 0
      ? setTimeout(() => {
          setSeconds(seconds - 1);
        }, 1000)
      : setSeconds(59);
    seconds < 0 && setMinutes((prev) => prev - 1);
    if (!minutes && !seconds) {
      clearInterval(intervalId);
      void Swal.fire({
        icon: 'warning',
        title: 'Tempo expirado, gere um novo pix!',
        iconColor: 'black',
        confirmButtonColor: 'black',
      });
      setShowPaymentMethod('');
    }
  }, [seconds, minutes]);

  return (
    <ContainerTimer>
      <Timer>{minutes}</Timer>:<Timer>{seconds < 10 ? `0${seconds}` : seconds}</Timer>
    </ContainerTimer>
  );
}
